import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "../../../components/select";
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory, useParams} from "react-router-dom";
import {
    update_establishments,
    clear_establishment,
    UPDATE_ESTABLISHMENTS_SUCCESS,
    get_all_establishments,
} from "../../../redux/establishment";
import LoadingSpinner from "../../../components/loading-spinner";
import {get_all_companies} from "../../../redux/company";
import {get_all_zones} from "../../../redux/zones";

/** @module  Pages/Establishment/UpdateEstablishments */

/**
 * @class UpdateEstablishments - Componente que renderiza la vista de actualizar establecimiento
 * @extends React.Component
 * @requires react-router-dom
 * @requires react-redux
 * @requires redux
 * @requires pages/admin/establishment/update.js
 * @requires components/breadcrumbs
 * @requires components/button
 * @requires components/input
 * @requires components/alert
 * @requires components/select
 * @requires components/link
 * @requires redux/establishment
 */

const UpdateEstablishments = () => {


    /**
     Un enlace que le permite usar el objeto de historial fuera de un componente.
     */
    const history = useHistory();


    /**
     *  Obtener la identificación de la url.
     */
    const {id} = useParams();


    /**
     *  Un enlace que le permite usar la función de despacho fuera de un componente.
     */
    const dispatch = useDispatch();


    /**
     *  Obtener los datos de la tienda redux.
     */
    const _establishment = useSelector(
        (state) => state.establishment_module._get_all_establishments
    );


    /**
     *  Obtener el token de la tienda redux.
     */
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    /**
     *  Obtener los datos de la tienda redux.
     */


    /* Obtener los datos de la tienda. */
    const _update_establishments = useSelector(
        (state) => state.establishment_module._update_establishments
    );


    /* Obtener los datos de la tienda. */
    const _companies = useSelector(
        (state) => state.company_module._get_all_companies
    );

    const _zones = useSelector(
        (state) => state.zone_module._get_all_zones
    );

    useEffect(() => {
        dispatch(get_all_companies(token));
        dispatch(get_all_zones(token));
    }, [token, dispatch]);

    /* Un estado que se utiliza para almacenar los datos del formulario. */
    const [form, setForm] = useState({
        codigo: "",
        nombre: "",
        id_empresa: 0,
        empresa: "",
        id_zona: 0,
        zona: "",
        calificacion_promedio: null,
    });

    /* Un estado que se utiliza para almacenar los datos del formulario. */
    const [companies, setCompanies] = useState([]);
    const [zones, setZones] = useState([]);

    const [isLoading, setIsLoading] = useState(false);


    /**
     *
     *  Este es una funcion flecha que se llama después de cada renderizado.
     * cuando el endpoint de actualizar establecimiento responda
     */
    useEffect(() => {
        if (_update_establishments.status === 200) {
            dispatch(clear_establishment(UPDATE_ESTABLISHMENTS_SUCCESS));
            dispatch(get_all_establishments(token));
            setIsLoading(false);
            history.push("/establecimientos");
        } else {
            if (_update_establishments.status !== 0) {
                toast.error(_update_establishments.message);
                setIsLoading(false);
            }
        }
    }, [_update_establishments, dispatch, history, token]);


    /**
     * funcion que se llama después de cada renderizado. Se utiliza para obtener los datos de la
     * tienda.
     */
    useEffect(() => {
        if (_companies.data.datos) {
            setCompanies(_companies.data.datos);
        }
    }, [_companies]);

    useEffect(() => {
        if (_zones.data.datos) {
            let value_zones = _zones.data.datos.filter(x => x.activo === true)
            setZones(value_zones);
        }
    }, [_zones]);


    /**
     *  Este es una funcion que se llama después de cada renderizado.
     * Se utiliza para obtener los datos del establecimiento a actualizar
     */
    useEffect(() => {
        if (_establishment && _establishment.data && _establishment.data.datos) {
            // eslint-disable-next-line
            _establishment.data.datos.map((item) => {
                if (parseInt(item.id) === parseInt(id)) {
                    setForm({
                        ...form,
                        codigo: item.codigo,
                        nombre: item.nombre,
                        id_empresa: item.id_empresa,
                        empresa: item.empresa,
                        id_zona: parseInt(item.id_zona),
                        zona: item.zona,
                        calificacion_promedio: item.calificacion_promedio,
                    });
                }
            });
        }
        // eslint-disable-next-line
    }, [_establishment, id]);

    // useEffect(() => {
    //     if (companies.length > 0) {
    //         // eslint-disable-next-line
    //         companies.map((item) => {
    //             // eslint-disable-next-line
    //             if (item.nombre === form.empresa) {
    //                 setForm({
    //                     ...form,
    //                     id_empresa: item.id,
    //                 });
    //                 console.log(item)
    //
    //             }
    //         })
    //     }
    //     // eslint-disable-next-line
    // }, [companies]);
    //
    // useEffect(() => {
    //     if (zones.length > 0) {
    //         // eslint-disable-next-line
    //         zones.map((item) => {
    //             // eslint-disable-next-line
    //             if (item.nombre === form.zona) {
    //                 console.log(item)
    //                 setForm({
    //                     ...form,
    //                     id_zona: item.id,
    //                 });
    //
    //             }
    //         })
    //     }
    //     // eslint-disable-next-line
    // }, [zones]);


    /**
     * Toma un evento como argumento, y si el nombre de destino del evento es igual a "id_empresa",
     * establece el id_empresa del formulario en el valor de destino del evento, analizado como un número
     * entero. De lo contrario, establece el formulario [e.target.name] en el valor objetivo del evento
     * @param e - El objeto de evento
     */
    const handleChange = (e) => {
        if (e.target.name === "id_empresa" || e.target.name === "id_zona") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    /**
     * Es una función que toma como parámetro un evento, previene la acción por defecto del evento,
     * valida los campos del formulario, y si los campos son válidos, despacha una acción para actualizar
     * el establecimiento
     * @param e - evento
     */
    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.codigo === "") {
            toast.error("Debe ingresar el código");
            setIsLoading(false);
            return;
        }
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre");
            setIsLoading(false);
            return;
        }
        if (form.id_empresa === 0) {
            toast.error("Debe seleccionar la empresa");
            setIsLoading(false);
            return;
        }

        if (form.id_zona === 0) {
            toast.error("Debe seleccionar la zona");
            setIsLoading(false);
            return;
        }

        dispatch(update_establishments(token, id, form));

    };
    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Establecimiento"
                            items={[
                                {label: "Establecimientos", link: "/establecimientos"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar establecimiento</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <Input
                                                label="Codigo"
                                                name="codigo"
                                                onChange={handleChange}
                                                value={form.codigo}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                label="Nombre"
                                                name="nombre"
                                                onChange={handleChange}
                                                value={form.nombre}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Empresa</label>

                                                <Select
                                                    label="Empresa"
                                                    name="id_empresa"
                                                    options={companies.map((company) => ({
                                                        name: company.nombre,
                                                        id: company.id,
                                                    }))}
                                                    onChange={handleChange}
                                                    value={form.id_empresa}
                                                    select={form.empresa}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Zona</label>

                                                <Select
                                                    label="Zona"
                                                    name="id_zona"
                                                    options={zones.map((item) => ({
                                                        name: item.nombre,
                                                        id: item.id,
                                                    }))}
                                                    onChange={handleChange}
                                                    value={form.id_zona}
                                                    select={form.zona}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-6">
                                            <label className="d-block">Calificaciones</label>
                                            {form.calificacion_promedio && form.calificacion_promedio.total > 0 ? (
                                                <span>
                                                    😞 {form.calificacion_promedio.malo}{' '}
                                                    😐 {form.calificacion_promedio.regular}{' '}
                                                    😊 {form.calificacion_promedio.bueno}{' '}
                                                    🥳 {form.calificacion_promedio.excelente}{' '}
                                                    = {form.calificacion_promedio.total}
                                                </span>
                                            ) : (
                                                <span className="text-muted">Sin calificaciones aún</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    <Link to="/establecimientos" className="btn btn-danger m-1">
                                        Cancelar
                                    </Link>
                                    <Button
                                        type="submit"
                                        text={
                                            <>
                                                <i className="bx bx-save"/> Guardar
                                            </>
                                        }
                                        theme="success"
                                        disabled={isLoading}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateEstablishments;
